<template>
  <div class="container mx-auto sm:px-6 lg:px-8 mt-8 mb-8">
    <div class="bg-white shadow overflow-hidden rounded-md">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
        <h3
          v-if="eventList?.length"
          class="text-lg leading-6 font-medium text-gray-900"
        >
          Select an event
        </h3>
        <h3
          v-if="!eventList?.length"
          class="text-lg leading-6 font-medium text-gray-900"
        >
          {{ tenantTheme?.brandName }} do not have any events scheduled at this
          time.
        </h3>
      </div>

      <div v-if="eventsListPending">
        Fetching available events...
      </div>
      <ul v-if="eventList" role="list" class="divide-y divide-gray-200">
        <li v-for="event in eventList" :key="event.id" class="px-6 py-4">
          <div class="sm:flex sm:items-start sm:justify-between">
            <div
              class="ml-3 flex gap-2 justify-between sm:flex-col sm:justify-normal sm:gap-1"
            >
              <div>
                <p class="text-sm text-gray-500">
                  <span class="font-light">{{
                    $dayjs(event?.startDate).format("ddd Do MMM YYYY")
                  }}</span>
                  <span
                    v-if="!$dayjs(event?.startDate).isSame(event?.endDate)"
                    class=""
                  >
                    to
                    <span class="font-light">{{
                      $dayjs(event?.endDate).format("ddd Do MMM YYYY")
                    }}</span>
                  </span>
                </p>
                <p class="text-lg font-medium text-gray-900">
                  {{ event?.title }}
                </p>
                <div v-if="devMode">
                  Developer Tools
                  <pre class="text-sm">
                                    {{ event }}
                                </pre>
                </div>
              </div>
              <p
                :class="[
                  event?.status === 'On Sale'
                    ? 'text-green-600'
                    : event?.status === 'Waitlist'
                      ? 'text-blue-600'
                      : 'text-red-600',
                ]"
              >
                {{ event?.status }}
              </p>
            </div>
            <div v-if="event?.status !== 'Off Sale'" class="mt-1 sm:mt-0">
              <NuxtLink
                as="button"
                :to="`/buy/tickets-${route?.params?.tenant}/event-${event?.slug}`"
                class="ml-3 sm:ml-0"
              >
                <button
                  type="button"
                  class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {{
                    event?.status === "On Sale"
                      ? "Buy  Tickets"
                      : "Join Waiting List"
                  }}
                </button>
              </NuxtLink>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
const { $dayjs } = useNuxtApp()

const tenantTheme = useTenantTheme()

useHead({
  title: `${tenantTheme.value.brandName} - Buy Tickets`
  // description: 'Buy tickets for the upcoming events',
})

definePageMeta({
  layout: 'order'
})

const route = useRoute()
const backend = useWetixBackend()

const devMode = route.query.devMode === 'true'

// Fetch list of events for the tenant.
const { data: eventList, pending: eventsListPending } =
  (await backend.getTenantEventsList(`${route.params.tenant}`)) as any
</script>
